module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("MAIN NAVIGATION")]), _vm._v(" "), (_vm.fullAdmin >= 30) ? _c('li', {
    staticClass: "treeview active"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/servers-data"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" "), _c('span', [_vm._v("Informations")])])], 1), _vm._v(" "), (_vm.fullAdmin >= 40) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/sql"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" "), _c('span', [_vm._v("Execute SQL")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 30) ? _c('li', {
    staticClass: "treeview active"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" "), _c('span', [_vm._v("Users")])])], 1), _vm._v(" "), (_vm.fullAdmin >= 40) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/all-info"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" "), _c('span', [_vm._v("Search User")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 33) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/ban"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" "), _c('span', [_vm._v("Ban")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 30) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/coins"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" "), _c('span', [_vm._v("Coins")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 30) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/facebook-switch"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" "), _c('span', [_vm._v("Facebook merge")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 33) ? _c('li', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 40) ? _c('li', [_vm._m(3)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "treeview active"
  }, [_vm._m(4), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(_vm.fullAdmin >= 20) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/chats/history"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" "), _c('span', [_vm._v("Chat History")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/admin-chat"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" "), _c('span', [_vm._v("Admin Chat")])])], 1), _vm._v(" "), _c('li', [(_vm.fullAdmin >= 20) ? _c('router-link', {
    attrs: {
      "to": "/chats"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" "), _c('span', [_vm._v("Chats")])]) : _vm._e()], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "treeview active"
  }, [_vm._m(5), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/skins"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('span', [_vm._v("Skins")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/private-skins"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('span', [_vm._v("Private skins")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/skins-managment"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" "), _c('span', [_vm._v("New skins "), _c('span', {
    staticClass: "label label-info"
  }, [_vm._v(_vm._s(_vm.$store.state.waitSkins))])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/private-skins-managment"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" "), _c('span', [_vm._v("New private skins "), _c('span', {
    staticClass: "label label-info"
  }, [_vm._v(_vm._s(_vm.$store.state.waitPrivateSkins))])])])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-cogs"
  }), _vm._v(" "), _c('span', [_vm._v("Servers")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', [_vm._v("User managment")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/analytic"
    }
  }, [_c('i', {
    staticClass: "fa fa-google"
  }), _vm._v(" "), _c('span', [_vm._v("Analytic")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/block-analytics"
    }
  }, [_c('i', {
    staticClass: "fa fa-google"
  }), _vm._v(" "), _c('span', [_vm._v("Block Analytic")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-comments"
  }), _vm._v(" "), _c('span', [_vm._v("Chats")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-picture-o"
  }), _vm._v(" "), _c('span', [_vm._v("Skins")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2cae5250!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Sidebar.vue
// module id = 306
// module chunks = 2